import metaElementsDefault from './metaElements.json'
import tagsElements from './tagsElements.json'

export default [
  '$scope',
  'storyService',
  'metaTemplatesService',
  'settingsService',
  'toastr',
  MetaBodyController,
]

function MetaBodyController(
  $scope,
  storyService,
  metaTemplatesService,
  settingsService,
  toastr
) {
  this.userRolesAuth = window.userRolesAuth
  this.elements =
    window.org_settings &&
    window.org_settings.v2 &&
    window.org_settings.v2.metas
      ? window.org_settings.v2.metas
      : metaElementsDefault
  this.tagsElements = tagsElements

  this.loadTags = ($query) => {
    return this.tagsElements.filter((theList) => {
      return theList.text.toLowerCase().indexOf($query.toLowerCase()) !== -1
    })
  }
}
